import { render, staticRenderFns } from "./DonationEmbed.vue?vue&type=template&id=a966d5a6&scoped=true&"
import script from "./DonationEmbed.vue?vue&type=script&lang=ts&"
export * from "./DonationEmbed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a966d5a6",
  null
  
)

export default component.exports